const map = {
	"./api/classes/AgenteDiaUtilApi.ts": 90983,
	"./api/classes/AtendimentoClienteApi.ts": 2165,
	"./api/classes/BaseApi.ts": 51110,
	"./api/classes/ClienteApi.ts": 35979,
	"./api/classes/ComissaoPorClassificacaoApi.ts": 43115,
	"./api/classes/ComumApi.ts": 64452,
	"./api/classes/ConhecimentoTransporteApi.ts": 52489,
	"./api/classes/CotacaoPerdidaApi.ts": 67822,
	"./api/classes/CupomDescontoApi.ts": 18250,
	"./api/classes/DesdobramentoApi.ts": 6314,
	"./api/classes/ErroDaApi.ts": 48540,
	"./api/classes/ErroDaApiEnterprise.ts": 61931,
	"./api/classes/FilialApi.ts": 8828,
	"./api/classes/ForncedorApi.ts": 31329,
	"./api/classes/FreteApi.ts": 85709,
	"./api/classes/LicenciamentoApi.ts": 10348,
	"./api/classes/LoginApi.ts": 99662,
	"./api/classes/MetasBonusApi.ts": 39062,
	"./api/classes/MicrouniversoApi.ts": 92806,
	"./api/classes/NotaFiscalEntradaApi.ts": 62354,
	"./api/classes/NotaFiscalSaidaApi.ts": 99003,
	"./api/classes/ObraAPI.ts": 12997,
	"./api/classes/OrcamentoApi.ts": 35239,
	"./api/classes/OrcamentoWebSnapshotApi.ts": 24601,
	"./api/classes/OrdemProducaoApi.ts": 16469,
	"./api/classes/ParametroApi.ts": 51888,
	"./api/classes/PermissaoFuncionalidadeApi.ts": 65616,
	"./api/classes/PessoaApi.ts": 21678,
	"./api/classes/ProdutoApi.ts": 59706,
	"./api/classes/SegurancaApi.ts": 89922,
	"./api/classes/TelemetriaApi.ts": 74207,
	"./api/classes/TipoPesquisaApi.ts": 90300,
	"./api/classes/UnificacaoDeOrcamentosApi.ts": 97269,
	"./api/classes/UsuarioApi.ts": 41977,
	"./api/classes/VendedorApi.ts": 94384,
	"./api/classes/WhatsappApi.ts": 97779,
	"./api/microuniversoApi.ts": 11159,
	"./api/types/DomainData.ts": 78610,
	"./api/types/DomainDataError.ts": 15434,
	"./api/types/DomainDataType.ts": 71178,
	"./api/types/PagedMessageResponse.ts": 26741,
	"./api/types/ResultadoOperacao.ts": 65077,
	"./api/types/RetornoApi.ts": 29921,
	"./asset-modules.d.ts": 46543,
	"./components/AlterarValidadePedido/AlterarValidadePedido.tsx": 3699,
	"./components/AlterarValidadePedido/AlterarValidadePedidoContainer.tsx": 59594,
	"./components/AnaliseGerencialProdutoItem/AnaliseGerencialProdutoItem.tsx": 9723,
	"./components/AnaliseGerencialProdutoItem/AnaliseGerencialProdutoItemContainer.tsx": 52758,
	"./components/DespesasOrcamento/DespesasOrcamento.tsx": 94255,
	"./components/DespesasOrcamento/DespesasOrcamentoContainer.tsx": 90470,
	"./components/Estoque/Estoque.tsx": 72339,
	"./components/Estoque/EstoqueContainer.tsx": 16842,
	"./components/Estoque/TableHead/AcoesHead.tsx": 55939,
	"./components/Estoque/TableHead/AcoesHeadEstoque.tsx": 20599,
	"./components/Estoque/TableHead/HeaderEstoque.tsx": 71433,
	"./components/Estoque/TableHead/MenuColunasEstoque.tsx": 29110,
	"./components/Estoque/TableHead/TableHeadEstoque.tsx": 87828,
	"./components/Estoque/TraduzirColunaGridEstoque.ts": 71544,
	"./components/Estoque/sub-consultas/encomenda/EncomendaProduto.tsx": 74490,
	"./components/Estoque/sub-consultas/encomenda/EncomendaProdutoContainer.tsx": 34412,
	"./components/Estoque/sub-consultas/notas-fiscais-pendentes/NotasFiscaisPendentes.tsx": 98375,
	"./components/Estoque/sub-consultas/notas-fiscais-pendentes/NotasFiscaisPendentesContainer.tsx": 50391,
	"./components/Estoque/sub-consultas/pedidos-cliente/PedidoClienteContainer.tsx": 41443,
	"./components/Estoque/sub-consultas/pedidos-cliente/PedidosCliente.tsx": 15878,
	"./components/Estoque/sub-consultas/pedidos-fornecedor/PedidosFornecedor.tsx": 41550,
	"./components/Estoque/sub-consultas/pedidos-fornecedor/PedidosFornecedorContainer.tsx": 8792,
	"./components/Estoque/sub-consultas/rma/Rma.tsx": 37720,
	"./components/Estoque/sub-consultas/rma/RmaContainer.tsx": 57087,
	"./components/HelloReact.tsx": 99425,
	"./components/ListaItensOrcamento.tsx": 54970,
	"./components/Loading/Loading.tsx": 35944,
	"./components/MuLinearProgress.tsx": 8709,
	"./components/abas/Abas.tsx": 27017,
	"./components/acompanhamento/Acompanhamento.tsx": 29088,
	"./components/acompanhamento/AcompanhamentoContainer.tsx": 38678,
	"./components/agregados/Agregados.tsx": 83266,
	"./components/agregados/AgregadosContainer.tsx": 86898,
	"./components/alterar-senha-vendedor/AlterarSenhaVendedor.tsx": 31685,
	"./components/alterar-senha-vendedor/AlterarSenhaVendedorContainer.tsx": 35920,
	"./components/alterar-senha-vendedor/AlterarSenhaVendedorContainerDialog.tsx": 82652,
	"./components/atendimento/Atendimento.tsx": 22407,
	"./components/atendimento/AtendimentoContainer.tsx": 4846,
	"./components/atendimento/AtendimentoForaOrcamento.tsx": 81811,
	"./components/atendimento/CadastrarAtendimento/CadastrarAtendimento.tsx": 86480,
	"./components/atendimento/CadastrarAtendimento/CadastrarAtendimentoContainer.tsx": 1671,
	"./components/atendimento/TableHead/AcoesHeadAtendimento.tsx": 14889,
	"./components/atendimento/TableHead/HeaderAtendimento.tsx": 22033,
	"./components/autorizado/Autorizado.tsx": 63928,
	"./components/autorizado/AutorizadoContainer.tsx": 99784,
	"./components/autorizado/autorizado-pesquisar/AutorizadoPesquisar.tsx": 90820,
	"./components/barra-informacoes-orcamento/BarraInformacoesOrcamento.tsx": 78576,
	"./components/barra-informacoes-orcamento/BarraInformacoesOrcamentoContainer.tsx": 9562,
	"./components/breadcrumb2/Breadcrumb2.tsx": 47481,
	"./components/breadcrumb2/Breadcrumb2Container.tsx": 73342,
	"./components/breadcrumb2/breadcrumb2Utils.ts": 13480,
	"./components/cabecalho-logo/CabecalhoLogo.tsx": 16913,
	"./components/cabecalho-logo/LockPersonIcon.tsx": 53406,
	"./components/calendario/Calendarios.tsx": 13169,
	"./components/cancelar-orcamento/AlterarValorNotaCreditoCancelamento.tsx": 78920,
	"./components/cashback/Cashback.tsx": 58781,
	"./components/cashback/CashbackContainer.tsx": 27444,
	"./components/comissoes/TelaComissoesContainer.tsx": 75834,
	"./components/comissoes/aba-indicadores-pesquisa/IndicadoresContainer.tsx": 13681,
	"./components/comissoes/aba-indicadores-pesquisa/PesquisaIndicadores.tsx": 6284,
	"./components/comissoes/aba-indicadores-pesquisa/detalhes-comissao/DetalhesComissao.tsx": 8496,
	"./components/comissoes/aba-indicadores-pesquisa/detalhes-comissao/DetalhesComissaoContainer.tsx": 62440,
	"./components/comissoes/aba-profissionais/AbaProfissionais.tsx": 12400,
	"./components/comissoes/aba-profissionais/AbaProfissionaisContainer.tsx": 87783,
	"./components/comissoes/aba-profissionais/inclusao-edicao-aba-profissionais/InclusaoEdicaoAbaProfissionais.tsx": 31081,
	"./components/comissoes/aba-profissionais/inclusao-edicao-aba-profissionais/InclusaoEdicaoAbaProfissionaisContanier.tsx": 80422,
	"./components/comissoes/aba-vendedores/PesquisaAbaVendedores.tsx": 24627,
	"./components/comissoes/aba-vendedores/VendedoresContainer.tsx": 68025,
	"./components/comissoes/aba-vendedores/adicionar-vendedor/AdicionarVendedor.tsx": 1478,
	"./components/comissoes/aba-vendedores/adicionar-vendedor/AdicionarVendedorContainer.tsx": 82806,
	"./components/comissoes/cadastro-indicador/TelaCadastroIndicadoresContainer.tsx": 78923,
	"./components/comissoes/cadastro-indicador/TelaDadosBasicos.tsx": 53348,
	"./components/comissoes/cadastro-indicador/TelaDadosBasicosContainer.tsx": 83524,
	"./components/comissoes/cadastro-indicador/aba-dados-adicionais/AbaDadosAdicionaisContainer.tsx": 94697,
	"./components/comissoes/cadastro-indicador/aba-dados-adicionais/AbaDadosAdiconais.tsx": 64066,
	"./components/comissoes/cadastro-indicador/aba-enderecos/AbaEnderecos.tsx": 58123,
	"./components/comissoes/cadastro-indicador/aba-enderecos/AbaEnderecosContainer.tsx": 80259,
	"./components/comissoes/cadastro-indicador/novo-endereco/NovoEnderecoComissoes.tsx": 54759,
	"./components/comissoes/cadastro-indicador/novo-endereco/NovoEnderecoComissoesContainer.tsx": 3470,
	"./components/comissoes/cadastro-indicador/novo-endereco/modal-selecionar-cep/ModalSelecionarCep.tsx": 23982,
	"./components/comparar-produtos/CompararProdutos.tsx": 87166,
	"./components/comparar-produtos/CompararProdutosContainer.tsx": 14955,
	"./components/componentes-basicos/BarraRolagemHorizontalSuperior.tsx": 23733,
	"./components/componentes-basicos/IconeFA.tsx": 15150,
	"./components/componentes-basicos/LimiteDeErroReact.tsx": 56105,
	"./components/consulta-comissao-por-classificacao/ComissaoPorClassificacao.tsx": 93615,
	"./components/consulta-comissao-por-classificacao/ComissaoPorClassificacaoContainer.tsx": 50982,
	"./components/consultar-itens/TableHead/HeaderConsultarItens.tsx": 40846,
	"./components/consultar-itens/TableHead/MenuColunasConsultarItens.tsx": 85105,
	"./components/consultar-itens/TableHead/TableHeadConsultarItens.tsx": 96223,
	"./components/consultar-meta-bonus/ConsultarMetaBonusContainer.tsx": 60166,
	"./components/consultar-meta-bonus/ConsultarMetaBonusResultado.tsx": 87084,
	"./components/cotacoes-perdidas/CotacoesPerdidas.tsx": 25936,
	"./components/cotacoes-perdidas/CotacoesPerdidasContainer.tsx": 2055,
	"./components/cotacoes-perdidas/CotacoesPerdidasForaOrcamento.tsx": 61274,
	"./components/cotacoes-perdidas/TableHead/AcoesHeadCotacoesPerdidas.tsx": 43350,
	"./components/cotacoes-perdidas/TableHead/HeadersCotacoesPerdidas.tsx": 79769,
	"./components/creditos/CreditosCliente.tsx": 21533,
	"./components/creditos/CreditosClienteContainer.tsx": 83060,
	"./components/cupom-desconto/CampanhasDeDescontosDisponiveis.tsx": 93941,
	"./components/cupom-desconto/CampanhasDeDescontosDisponiveisContainer.tsx": 18468,
	"./components/cupom-desconto/detalhamento-campanha-desconto-disponivel/DetalhamentoCampanhaDeDesconto.tsx": 89232,
	"./components/cupom-desconto/detalhamento-campanha-desconto-disponivel/DetalhamentoCampanhaDeDescontoContainer.tsx": 9981,
	"./components/descontos/Descontos.tsx": 5008,
	"./components/descontos/DescontosContainer.tsx": 20134,
	"./components/desdobramento/Desdobramento.tsx": 11751,
	"./components/desdobramento/DesdobramentoContainer.tsx": 71822,
	"./components/destinoTransferencia/DestinoTransferencia.tsx": 89696,
	"./components/destinoTransferencia/DestinoTransferenciaContainer.tsx": 21098,
	"./components/dialog-arrastavel/PaperArrastavel.tsx": 8560,
	"./components/documentos-abertos-informacoes/DocumentosAbertosInformacoes.tsx": 71927,
	"./components/documentos-abertos-informacoes/DocumentosAbertosInformacoesContainer.tsx": 8478,
	"./components/documentos-abertos/DocumentosAbertos.tsx": 27365,
	"./components/documentos-abertos/DocumentosAbertosContainer.tsx": 89171,
	"./components/dropdown-exibicao-itens/DropdownExibicaoItens.tsx": 48108,
	"./components/editar-item/EditarItem.tsx": 3564,
	"./components/editar-item/EditarItemContainer.tsx": 69823,
	"./components/editar-item/TelaEdicaoItensContainer.tsx": 44399,
	"./components/editar-item/editar-preco-tinta/EditarPrecoTinta.tsx": 47813,
	"./components/editar-item/editar-preco-tinta/EditarPrecoTintaContainer.tsx": 7148,
	"./components/editar-item/modal-simular-descontos/ModalSimularDesconto.tsx": 28313,
	"./components/editar-item/modal-simular-descontos/ModalSimularDescontoContainer.tsx": 37549,
	"./components/editar-item/modal-venda-sob-encomenda/DadosEncomenda.ts": 77076,
	"./components/editar-item/modal-venda-sob-encomenda/ModalVendaSobEncomenda.tsx": 90196,
	"./components/editar-item/modal-venda-sob-encomenda/ModalVendaSobEncomendaContainer.tsx": 81659,
	"./components/editar-item/produto-sem-estoque-disponivel/ProdutoSemEstoqueDisponivel.tsx": 31825,
	"./components/editar-item/produto-sem-estoque-disponivel/ProdutoSemEstoqueDisponivelContainer.tsx": 55375,
	"./components/editar-item/registrar-perda-cotacao/RegistarPerdaCotacao.tsx": 7764,
	"./components/editar-item/registrar-perda-cotacao/RegistrarPerdaCotacaoContainer.tsx": 16900,
	"./components/editorTexto/EditorDeTexto.tsx": 65183,
	"./components/enderecosOrcamento/GridEnderecosOrcamentoContainer.tsx": 70152,
	"./components/enderecosOrcamento/grid-enderecosOrcamento/GridEnderecosOrcamento.tsx": 52347,
	"./components/enderecosOrcamento/grid-enderecosOrcamento/table-head/AcoesHeadEnderecosOrcamento.tsx": 29432,
	"./components/entrega/TelaEntrega.tsx": 95947,
	"./components/entrega/TelaEntregaContainer.tsx": 53682,
	"./components/entrega/aba-entrega/aba-entrega.tsx": 56808,
	"./components/entrega/aba-tipo-entrega/AbaTipoEntrega.tsx": 91480,
	"./components/entrega/aba-tipo-entrega/editar-tipo-entrega/EditarTipoEntrega.tsx": 42627,
	"./components/entrega/aba-tipo-entrega/editar-tipo-entrega/EditarTipoEntregaContainer.tsx": 87866,
	"./components/entrega/aba-transportadora/AbaTransportadora.tsx": 4017,
	"./components/entrega/frete/AbaFrete.tsx": 82517,
	"./components/entrega/frete/Editar-frete/EditarFrete.tsx": 13268,
	"./components/entrega/frete/Editar-frete/EditarFreteContainer.tsx": 90683,
	"./components/faturamento/Faturamento.tsx": 88785,
	"./components/faturamento/FaturamentoContainer.tsx": 26033,
	"./components/ficha-crediario-cliente/FichaCrediarioCliente.tsx": 90590,
	"./components/ficha-crediario-cliente/FichaCrediarioClienteContainer.tsx": 10885,
	"./components/ficha-financeira/FichaFinanceiraCliente.tsx": 15842,
	"./components/ficha-financeira/FichaFinanceiraClienteContainer.tsx": 39177,
	"./components/finalizar-orcamento/FinalizarOrcamento.tsx": 21504,
	"./components/finalizar-orcamento/FinalizarOrcamentoContainer.tsx": 34197,
	"./components/finalizar-orcamento/disponibilidade-capacidade-de-carga/ChaveAgrupamento.ts": 14592,
	"./components/finalizar-orcamento/disponibilidade-capacidade-de-carga/DadosPorItem.ts": 16117,
	"./components/finalizar-orcamento/disponibilidade-capacidade-de-carga/DataCapacidadeDeCarga.ts": 85506,
	"./components/finalizar-orcamento/disponibilidade-capacidade-de-carga/DisponibilidadeCapacidadeCargaContainer.tsx": 11080,
	"./components/finalizar-orcamento/disponibilidade-capacidade-de-carga/DisponibilidadeCapacidadeCargaPorItemOrcamento.tsx": 43818,
	"./components/finalizar-orcamento/disponibilidade-capacidade-de-carga/DisponibilidadeCapacidadeCargaPorItensAgrupados.tsx": 84383,
	"./components/finalizar-orcamento/disponibilidade-capacidade-de-carga/DisponibilidadeCapacidadeDeCarga.tsx": 66692,
	"./components/finalizar-orcamento/disponibilidade-capacidade-de-carga/LegendaDisponibilidadeCapacidadeDeCarga.tsx": 7612,
	"./components/finalizar-orcamento/disponibilidade-capacidade-de-carga/Situacao.ts": 61733,
	"./components/finalizar-orcamento/disponibilidade-capacidade-de-carga/ValorAgrupamento.ts": 30851,
	"./components/finalizar-orcamento/disponibilidade-capacidade-de-carga/traduzirSituacao.ts": 79694,
	"./components/finalizar-orcamento/perguntasFinalizacao.ts": 46600,
	"./components/formas-de-pagamento/FormaDePagamentoContainer.tsx": 48048,
	"./components/formas-de-pagamento/PlanoDePagamentoContainer.tsx": 17346,
	"./components/formas-de-pagamento/TelaFormaDePagamentoContainer.tsx": 49581,
	"./components/formas-de-pagamento/aba-forma-de-pagamento/AbaFormaDePagamento.tsx": 97356,
	"./components/formas-de-pagamento/aba-plano-pagamento/AbaPlanoPagamento.tsx": 57959,
	"./components/formas-de-pagamento/editar-parcela-contrato/EditarParcelaContrato.tsx": 51966,
	"./components/formas-de-pagamento/editar-parcela-contrato/EditarParcelaContratoContainer.tsx": 18230,
	"./components/formas-de-pagamento/incluir-editar-parcela/IncluirEditarParcela.tsx": 37292,
	"./components/formas-de-pagamento/incluir-editar-parcela/IncluirEditarParcelaContainer.tsx": 28890,
	"./components/formas-de-pagamento/incluir-editar-parcela/encontrarTipoDocumentoPorTipoParcela.ts": 90777,
	"./components/formas-de-pagamento/simular-financiamento/SimularFinanciamento.tsx": 96656,
	"./components/formas-de-pagamento/simular-financiamento/SimularFinanciamentoContainer.tsx": 86101,
	"./components/frete-por-peso-cubagem/FretePorPesoCubagem.tsx": 34860,
	"./components/frete-por-peso-cubagem/FretePorPesoCubagemContainer.tsx": 72099,
	"./components/frete-por-peso-cubagem/ItemDadosFreteProduto.tsx": 47364,
	"./components/frete-por-peso-cubagem/funcoes.ts": 82303,
	"./components/frete-por-peso-cubagem/funcoesTiposFrete.ts": 83250,
	"./components/frete-por-peso-cubagem/tipos.ts": 50291,
	"./components/getComponentWithStore.tsx": 65381,
	"./components/iniciar-orcamento/IniciarOrcamento.tsx": 80053,
	"./components/iniciar-orcamento/IniciarOrcamentoContainer.tsx": 28037,
	"./components/iniciar-orcamento/IniciarOrcamentoContainerDialog.tsx": 12709,
	"./components/inputs/InputCep.tsx": 22352,
	"./components/inputs/InputCnpj.tsx": 90995,
	"./components/inputs/InputCpf.tsx": 93221,
	"./components/inputs/InputCpfCnpj.tsx": 91624,
	"./components/inputs/InputData.tsx": 85130,
	"./components/inputs/InputDataCalendario.tsx": 3464,
	"./components/inputs/InputMascara.tsx": 97706,
	"./components/inputs/InputMascaraDinamica.tsx": 97002,
	"./components/inputs/InputNumerico.tsx": 50858,
	"./components/inputs/InputTelefoneCelular.tsx": 40636,
	"./components/itens-orcamento/ItensOrcamentoContainer.tsx": 4185,
	"./components/itens-orcamento/Lotes/lotesValidade.tsx": 98122,
	"./components/itens-orcamento/Lotes/lotesValidadeContainer.tsx": 28555,
	"./components/itens-orcamento/ambiente/AmbienteItem.tsx": 96087,
	"./components/itens-orcamento/ambiente/AmbienteItemComMenu.tsx": 98957,
	"./components/itens-orcamento/ambiente/MenuDeAmbientes.tsx": 83079,
	"./components/itens-orcamento/barra-ferramentas/BarraFerramentas.tsx": 67243,
	"./components/itens-orcamento/barra-pesquisa-incluir-item/BarraPesquisa.tsx": 93706,
	"./components/itens-orcamento/consulta-itens/ConsultaItens.tsx": 83975,
	"./components/itens-orcamento/consulta-itens/ConsultaItensDialog.tsx": 74487,
	"./components/itens-orcamento/consulta-itens/ItemConsultaItens.tsx": 25280,
	"./components/itens-orcamento/consulta-itens/ObterTh.tsx": 70281,
	"./components/itens-orcamento/consulta-itens/RodapeConsultaItens.tsx": 3108,
	"./components/itens-orcamento/consulta-itens/Td.tsx": 39013,
	"./components/itens-orcamento/consulta-itens/Th.tsx": 34769,
	"./components/itens-orcamento/consulta-itens/dadosOrcamentoParaTeste.tsx": 6165,
	"./components/itens-orcamento/detatlhe-item/DetalheItem.tsx": 50617,
	"./components/itens-orcamento/detatlhe-item/DetalheItemContainer.tsx": 52320,
	"./components/itens-orcamento/grid-itens/GridItens.tsx": 35682,
	"./components/itens-orcamento/grid-itens/Item.tsx": 62374,
	"./components/itens-orcamento/grid-itens/funcoesInformacoesGriditens.ts": 11854,
	"./components/itens-orcamento/grid-itens/head/AcoesHead.tsx": 8092,
	"./components/itens-orcamento/grid-itens/head/TableHead.tsx": 88679,
	"./components/itens-orcamento/grid-itens/largurasColunasFixas.ts": 25797,
	"./components/itens-orcamento/grid-itens/obterColunas.ts": 58055,
	"./components/itens-orcamento/grid-itens/obterColunasConsultaItens.ts": 66829,
	"./components/itens-orcamento/grid-itens/obterColunasEstoquesFiliais.ts": 60951,
	"./components/itens-orcamento/grid-itens/obterColunasEstoquesFiliaisConsultaritens.ts": 40869,
	"./components/itens-orcamento/grid-itens/obterStyleColunasFixas.ts": 14959,
	"./components/itens-orcamento/incluir-item/IncluirItem.tsx": 49447,
	"./components/itens-orcamento/legenda/Legenda.tsx": 90430,
	"./components/itens-orcamento/localizarOrcamentoEmAndamentoOrfaoDeOutraAba.ts": 78680,
	"./components/itens-orcamento/lotes-reservados/LotesReservados.tsx": 5521,
	"./components/itens-orcamento/lotes-reservados/LotesReservadosContainer.tsx": 88656,
	"./components/itens-orcamento/modal-simular-descontos/modalSimularDesconto_NAOUSADO.tsx": 4942,
	"./components/itens-orcamento/ofertas/ofertas.tsx": 92249,
	"./components/itens-orcamento/ofertas/ofertasContainer.tsx": 48585,
	"./components/itens-orcamento/orcamento-concluido/modal-imprimir/modalEnviarEmail/modalEnviarEmail.tsx": 25684,
	"./components/itens-orcamento/orcamento-concluido/modal-imprimir/modalEnviarEmail/modalEnviarEmailContainer.tsx": 97025,
	"./components/itens-orcamento/orcamento-concluido/modal-imprimir/modalEnviarWhatsapp/modalEnviarWhatsapp.tsx": 38654,
	"./components/itens-orcamento/orcamento-concluido/modal-imprimir/modalEnviarWhatsapp/modalEnviarWhatsappContainer.tsx": 67315,
	"./components/itens-orcamento/orcamento-concluido/modal-imprimir/modalImprimir.tsx": 44512,
	"./components/itens-orcamento/orcamento-concluido/modal-imprimir/modalImprimirContainer.tsx": 612,
	"./components/itens-orcamento/orcamento-concluido/orcamentoConcluido.tsx": 12940,
	"./components/itens-orcamento/orcamento-concluido/orcamentoConcluidoContainer.tsx": 91056,
	"./components/itens-orcamento/ordenar-itens/OrdenarItens.tsx": 15731,
	"./components/itens-orcamento/paginacao/Paginacao.tsx": 92452,
	"./components/itens-orcamento/produto-controle-lote/ProdutosControleLote.tsx": 85255,
	"./components/itens-orcamento/produto-controle-lote/ProdutosControleLoteContainer.tsx": 92280,
	"./components/itens-orcamento/produto-controle-lote/produto-lote-editar/ProdutoLoteEditar.tsx": 24878,
	"./components/itens-orcamento/produto-controle-lote/produto-lote-editar/ProdutoLoteEditarContainer.tsx": 67349,
	"./components/itens-orcamento/produto-controle-lote/produto-lote/ProdutoLote.tsx": 34786,
	"./components/itens-orcamento/produto-controle-lote/produto-lote/ProdutoLoteContainer.tsx": 93050,
	"./components/itens-orcamento/reserva-produto/ReservaProdutoContainer.tsx": 8850,
	"./components/itens-orcamento/reserva-produto/Reservaproduto.tsx": 77277,
	"./components/itens-orcamento/tributação/Tributacao.tsx": 65358,
	"./components/itens-orcamento/tributação/TributacaoContainer.tsx": 25813,
	"./components/itens-orcamento/useRecuperarCestaProdutosAnterior.ts": 56923,
	"./components/itens-orcamento/useRecuperarOrcamentoEmAndamento.ts": 40026,
	"./components/limite-credito/LimiteCredito.tsx": 15903,
	"./components/limite-credito/LimiteCreditoContainer.tsx": 58445,
	"./components/login/Login.tsx": 16379,
	"./components/login/LoginContainer.tsx": 36962,
	"./components/madeira/TratamentoMadeira.tsx": 87872,
	"./components/madeira/TratamentoMadeiraContainer.tsx": 31547,
	"./components/madeira/TratamentoMadeiraItemContainer.tsx": 78660,
	"./components/markup/TelaMarkup.tsx": 5001,
	"./components/markup/TelaMarkupContainer.tsx": 32336,
	"./components/markup/grid-markup/EstilosIndividuaisNomeColunasMarkup.ts": 9065,
	"./components/markup/grid-markup/GridMarkup.tsx": 51433,
	"./components/markup/grid-markup/table-head/AcoesHeadMarkup.tsx": 24194,
	"./components/markup/grid-markup/table-head/HeadGridMarkup.tsx": 55817,
	"./components/markup/grid-markup/table-head/TraduzirNomeColunaMarkup.ts": 82151,
	"./components/markup/senha-markup/SenhaMarkup.tsx": 91779,
	"./components/markup/total-geral-markup/TotalGeralMarkup.tsx": 30137,
	"./components/mascaraPrecoVendaComponent.js": 22343,
	"./components/materialUiTheme.ts": 27454,
	"./components/menu-consulta-produtos/MenuConsultaProdutos.tsx": 60909,
	"./components/menu-consulta-produtos/MenuConsultasProdutoContainer.tsx": 33112,
	"./components/menu-consulta-produtos/useMenuConsultaProduto.tsx": 20087,
	"./components/menu-consultas-cliente/MenuConsultasCliente.tsx": 63655,
	"./components/menu-consultas-cliente/MenuConsultasClienteContainer.tsx": 48142,
	"./components/menu-principal/MenuPrincipal.tsx": 76788,
	"./components/menu-principal/MenuPrincipalContainer.tsx": 69273,
	"./components/menu-sub-consulta-produto/MenuSubConsultaProduto.tsx": 78504,
	"./components/menu-sub-consulta-produto/MenuSubConsultaProdutoContainer.tsx": 99791,
	"./components/menu-sub-consulta-produto/useMenuSubConsultaProduto.tsx": 68705,
	"./components/modal-permissao-senha/ModalPermissaoSenha.tsx": 20881,
	"./components/modal-permissao-senha/ModalPermissaoSenhaContainer.tsx": 3528,
	"./components/modalConfigurarWhatsapp/modalConfigurarWhatsapp.tsx": 43945,
	"./components/modalConfigurarWhatsapp/modalConfigurarWhatsappContainer.tsx": 7718,
	"./components/movimentacao-estoque/MovimentacaoEstoque.tsx": 43083,
	"./components/movimentacao-estoque/MovimentacaoEstoqueContainer.tsx": 37339,
	"./components/orcamento-aberto/OrcamentoEmAberto.tsx": 43094,
	"./components/orcamento-aberto/OrcamentoEmAbertoContainer.tsx": 42197,
	"./components/ordem-producao/CancelarGeracaoOrdemProducao.tsx": 90785,
	"./components/ordem-producao/CancelarGeracaoOrdemProducaoContainer.tsx": 38776,
	"./components/ordem-producao/OrdemProducao.tsx": 55402,
	"./components/ordem-producao/OrdemProducaoContainer.tsx": 46177,
	"./components/ordem-producao/confirmar-etapa-producao/ConfirmarEtapaProducao.tsx": 49745,
	"./components/ordem-producao/confirmar-etapa-producao/ConfirmarEtapaProducaoContainer.tsx": 2440,
	"./components/ordem-producao/consulta-ordem-de-producao-aberto/ConsultaOrdemDeProducaoAberto.tsx": 54977,
	"./components/ordem-producao/consulta-ordem-de-producao-aberto/ConsultaOrdemDeProducaoAbertoContainer.tsx": 11704,
	"./components/ordem-producao/consulta-ordem-de-producao/ConsultaOrdemDeProducao.tsx": 32232,
	"./components/ordem-producao/consulta-ordem-de-producao/ConsultaOrdemDeProducaoContainer.tsx": 66405,
	"./components/ordem-producao/consultar-etapa-ordem-producao/ConsultarEtapaOrdemProducao.tsx": 76000,
	"./components/ordem-producao/consultar-insumo-ordem-producao/ConsultarInsumoOrdemProducao.tsx": 62450,
	"./components/ordem-producao/inclusao-insumo/InclusaoInsumo.tsx": 91248,
	"./components/ordem-producao/inclusao-insumo/InclusaoInsumoContainer.tsx": 23569,
	"./components/ordem-producao/pesquisa-ordem-producao/PesquisaOrdemProducao.tsx": 42285,
	"./components/ordem-producao/pesquisa-ordem-producao/PesquisaOrdermProducaoContainer.tsx": 63106,
	"./components/painel/Painel.tsx": 73728,
	"./components/perfil-button/PerfilButton.tsx": 24710,
	"./components/perfil-button/PerfilButtonContainer.tsx": 20371,
	"./components/pesquisa-cliente/AbasPesquisaClienteContainer.tsx": 6266,
	"./components/pesquisa-cliente/PesquisaClienteForaOrcamento.tsx": 16758,
	"./components/pesquisa-cliente/PesquisarCliente.tsx": 23308,
	"./components/pesquisa-cliente/PesquisarClienteContainer.tsx": 21795,
	"./components/pesquisa-cliente/TableHead/AcoesHead.tsx": 70600,
	"./components/pesquisa-cliente/TableHead/HeadersPesquisarCliente.tsx": 97013,
	"./components/pesquisa-cliente/TableHead/MenuColunasPesquisarCliente.tsx": 22143,
	"./components/pesquisa-cliente/TableHead/TableHeadPesquisarCliente.tsx": 8549,
	"./components/pesquisa-cliente/aba-classificacao/AbaClassificacao.tsx": 16224,
	"./components/pesquisa-cliente/aba-classificacao/AbaClassificacaoContainer.tsx": 88834,
	"./components/pesquisa-cliente/aba-enderecos/AbaEnderecosCliente.tsx": 16803,
	"./components/pesquisa-cliente/aba-enderecos/AbaEnderecosClienteContainer.tsx": 81690,
	"./components/pesquisa-cliente/aba-enderecos/novo-endereco/NovoEnderecoCliente.tsx": 60539,
	"./components/pesquisa-cliente/aba-enderecos/novo-endereco/NovoEnderecoClienteContainer.tsx": 27650,
	"./components/pesquisa-cliente/aba-enderecos/novo-endereco/modal-selecionar-cep/ModalSelecionarCep.tsx": 92385,
	"./components/pesquisa-cliente/dados-basicos-nao-cadastrado/AbasPesquisaClienteNaoCadastradoContainer.tsx": 833,
	"./components/pesquisa-cliente/dados-basicos-nao-cadastrado/DadosBasicosClienteNaoCadastrado.tsx": 57271,
	"./components/pesquisa-cliente/dados-basicos-nao-cadastrado/DadosBasicosClienteNaoCadastradoContainer.tsx": 35966,
	"./components/pesquisa-cliente/dados-basicos-pesquisa-clientes/DadosBasicosCliente.tsx": 19901,
	"./components/pesquisa-cliente/dados-basicos-pesquisa-clientes/DadosBasicosClienteContainer.tsx": 99988,
	"./components/pesquisa-cliente/dados-cliente/DadosCliente.tsx": 51809,
	"./components/pesquisa-cliente/dados-cliente/DadosClienteContainer.tsx": 45784,
	"./components/pesquisa-cliente/documentos-quitados/DocumentoQuitado.tsx": 68930,
	"./components/pesquisa-cliente/documentos-quitados/DocumentoQuitadoContainer.tsx": 12528,
	"./components/pesquisa-cliente/documentos-quitados/table-head/AcoesHeadDocumentosQuitados.tsx": 98616,
	"./components/pesquisa-cliente/pendencia-cliente/ClienteComLimiteCreditoBloqueado/ClienteComLimiteCreditoBloqueado.tsx": 16829,
	"./components/pesquisa-cliente/pendencia-cliente/PendenciaCliente.tsx": 95669,
	"./components/pesquisa-cliente/pendencia-cliente/PendenciaClienteContainer.tsx": 91708,
	"./components/pesquisa-cliente/pendencia-cliente/areaDeVenda/PendenciaAreaDeVenda.tsx": 99484,
	"./components/pesquisa-cliente/pendencia-cliente/orcamentoEmAberto/OrcamentoEmAberto.tsx": 84685,
	"./components/pesquisa-cliente/pendencia-cliente/vendedorRelacionado/vendedorRelacionado.tsx": 30465,
	"./components/pesquisa-orcamento/PesquisaOrcamento.tsx": 619,
	"./components/pesquisa-orcamento/PesquisaOrcamentoContainer.tsx": 40103,
	"./components/pesquisa-orcamento/cancelar-orcamento/CancelarOrcamento.tsx": 11759,
	"./components/pesquisa-orcamento/cancelar-orcamento/CancelarOrcamentoContainer.tsx": 38022,
	"./components/pesquisa-orcamento/cancelar-orcamento/ModalConfirmarCreditoCancelamento/ModalConfirmarCreditoCancelamento.tsx": 88637,
	"./components/pesquisa-orcamento/conhecimento-transporte/ConhecimentoTransporte.tsx": 57527,
	"./components/pesquisa-orcamento/conhecimento-transporte/ConhecimentoTransporteContainer.tsx": 75518,
	"./components/pesquisa-orcamento/devolucoes-orcamento/DevolucoesOrcamento.tsx": 3331,
	"./components/pesquisa-orcamento/devolucoes-orcamento/DevolucoesOrcamentoContainer.tsx": 57818,
	"./components/pesquisa-orcamento/devolucoes-orcamento/sub-consultas/financeiro/DevolucoesFinanceiro.tsx": 66948,
	"./components/pesquisa-orcamento/devolucoes-orcamento/sub-consultas/financeiro/DevolucoesFinanceiroContainer.tsx": 59211,
	"./components/pesquisa-orcamento/devolucoes-orcamento/sub-consultas/itens/DevolucoesItens.tsx": 37688,
	"./components/pesquisa-orcamento/devolucoes-orcamento/sub-consultas/itens/DevolucoesItensContainer.tsx": 42943,
	"./components/pesquisa-orcamento/historico-orcamento/HistoricoOrcamento.tsx": 22793,
	"./components/pesquisa-orcamento/historico-orcamento/HistoricoOrcamentoContainer.tsx": 70480,
	"./components/pesquisa-orcamento/menu-consultas-pesquisa-orcamento/MenuConsultasPesquisaOrcamento.tsx": 92685,
	"./components/pesquisa-orcamento/menu-consultas-pesquisa-orcamento/MenuConsultasPesquisaOrcamentoContainer.tsx": 15748,
	"./components/pesquisa-orcamento/menu-consultas-pesquisa-orcamento/useMenuConsultasPesquisaOrcamento.tsx": 5684,
	"./components/pesquisa-orcamento/menu-sub-consultas-devolucoes/MenuSubConsultasDevolucoes.tsx": 23545,
	"./components/pesquisa-orcamento/menu-sub-consultas-devolucoes/MenuSubConsultasDevolucoesContainer.tsx": 768,
	"./components/pesquisa-orcamento/menu-sub-consultas-devolucoes/useMenuSubConsultasDevolucoes.tsx": 67516,
	"./components/pesquisa-orcamento/menu-sub-consultas-nota-fiscal/MenuSubConsultasNotaFiscal.tsx": 30956,
	"./components/pesquisa-orcamento/menu-sub-consultas-nota-fiscal/MenuSubConsultasNotaFiscalContainer.tsx": 75107,
	"./components/pesquisa-orcamento/menu-sub-consultas-nota-fiscal/useMenuSubConsultasNotaFiscal.tsx": 78421,
	"./components/pesquisa-orcamento/notas-fiscais/NotasFiscais.tsx": 71077,
	"./components/pesquisa-orcamento/notas-fiscais/NotasFiscaisContainer.tsx": 13644,
	"./components/pesquisa-orcamento/notas-fiscais/sub-consultas/Itens/NotaFiscalItens.tsx": 93359,
	"./components/pesquisa-orcamento/notas-fiscais/sub-consultas/Itens/NotaFiscalItensContainer.tsx": 87910,
	"./components/pesquisa-orcamento/notas-fiscais/sub-consultas/entrega/NotasFiscaisEntrega.tsx": 80784,
	"./components/pesquisa-orcamento/notas-fiscais/sub-consultas/entrega/NotasFiscaisEntregaContainer.tsx": 76455,
	"./components/pesquisa-orcamento/notas-fiscais/sub-consultas/expedicao/NotasFiscaisExpedicao.tsx": 14844,
	"./components/pesquisa-orcamento/notas-fiscais/sub-consultas/expedicao/NotasFiscaisExpedicaoContainer.tsx": 1715,
	"./components/pesquisa-orcamento/notas-fiscais/sub-consultas/financeiro/NotaFiscalFinanceiro.tsx": 41045,
	"./components/pesquisa-orcamento/notas-fiscais/sub-consultas/financeiro/NotaFiscalFinanceiroContainer.tsx": 82844,
	"./components/pesquisa-orcamento/notas-fiscais/sub-consultas/lotes/NotaFiscalLotes.tsx": 57663,
	"./components/pesquisa-orcamento/notas-fiscais/sub-consultas/lotes/NotaFiscalLotesContainer.tsx": 26326,
	"./components/pesquisa-orcamento/table-head/AcoesHeadPesquisaOrcamento.tsx": 15641,
	"./components/pesquisa-orcamento/table-head/EstilosIndividuaisNomeColunasPesquiaOrcamento.ts": 63207,
	"./components/pesquisa-orcamento/table-head/HeadPesquisaOrcamento.tsx": 44663,
	"./components/pesquisa-orcamento/table-head/TraduzirNomeColunaPesquisaOrcamento.ts": 51992,
	"./components/pesquisa-orcamento/trocar-filial-orcamento/TrocarFilialOrcamento.tsx": 72890,
	"./components/pesquisa-orcamento/trocar-filial-orcamento/TrocarFilialOrcamentoContainer.tsx": 38065,
	"./components/pesquisa-produtos/PaginaPesquisaProdutoContainer.tsx": 78904,
	"./components/pesquisa-produtos/PesquisaProdutoForaOrcamento.tsx": 29035,
	"./components/pesquisa-produtos/detalhes-produto/DetalhesProduto.tsx": 18981,
	"./components/pesquisa-produtos/detalhes-produto/DetalhesProdutoContainer.tsx": 71942,
	"./components/pesquisa-produtos/grid-itens/GridItensPesquisaProdutos.tsx": 60916,
	"./components/pesquisa-produtos/grid-itens/Headers/AcoesHeadGridItens.tsx": 98371,
	"./components/pesquisa-produtos/grid-itens/Headers/HeadersPesquisaProdutos.tsx": 84688,
	"./components/pesquisa-produtos/grid-itens/Headers/TableHeadPesquisaProdutos.tsx": 4958,
	"./components/pesquisa-produtos/grid-itens/TBody/ItemPesquisaProduto.tsx": 70990,
	"./components/pesquisa-produtos/grid-itens/TraduzirOrdenarNomeColunaPesquisaProduto.ts": 81415,
	"./components/pesquisa-produtos/grid-itens/barra-ferramentas-grid/BarraFerramentasGrid.tsx": 19911,
	"./components/pesquisa-produtos/grid-itens/barra-ferramentas-grid/BarraFerramentasGridPesquisaProdutos.tsx": 96400,
	"./components/pesquisa-produtos/grid-itens/barra-ferramentas-grid/TabelaProdutosSelecionados.tsx": 93599,
	"./components/pesquisa-produtos/mais-filtros/MaisFiltros.tsx": 86633,
	"./components/pesquisa-produtos/pagina-pesquisa-produto/PaginaPesquisaProduto.tsx": 26161,
	"./components/pesquisa-produtos/pesquisa-classe/PesquisaClasse.tsx": 24149,
	"./components/pesquisa-produtos/pesquisa-classe/PesquisaClasseContainer.tsx": 86334,
	"./components/pesquisa-produtos/pesquisa-cor-tintometrico/PesquisaCorTintometrico.tsx": 14476,
	"./components/pesquisa-produtos/pesquisa-cor-tintometrico/PesquisaCorTintometricoContainer.tsx": 52771,
	"./components/pesquisa-produtos/pesquisa-cor/PesquisaCor.tsx": 21813,
	"./components/pesquisa-produtos/pesquisa-cor/PesquisaCorContainer.tsx": 33756,
	"./components/pesquisa-produtos/pesquisa-cor/PesquisaCorTinta.tsx": 89993,
	"./components/pesquisa-produtos/pesquisa-cor/PesquisaCorTintaContainer.tsx": 8432,
	"./components/pesquisa-produtos/pesquisa-cor/cor-selecionada/CorTintaSelecionada.tsx": 54098,
	"./components/pesquisa-produtos/pesquisa-fornecedor/PesquisaFornecedor.tsx": 64379,
	"./components/pesquisa-produtos/pesquisa-fornecedor/PesquisaFornecedorContainer.tsx": 83322,
	"./components/pesquisa-produtos/pesquisa-pre-vendas/PesquisaPreVendaContainer.tsx": 39948,
	"./components/pesquisa-produtos/pesquisa-pre-vendas/PesquisaPreVendas.tsx": 43066,
	"./components/pesquisa-produtos/pesquisa-pre-vendas/TableHead/AcoesHeadPesquisaPreVenda.tsx": 95867,
	"./components/pesquisa-produtos/pesquisa-pre-vendas/TableHead/HeadersPesquisaPreVendas.tsx": 50845,
	"./components/pesquisa-produtos/pesquisa-pre-vendas/TableHead/TableHeadPesquisaPreVendas.tsx": 43921,
	"./components/pesquisa-produtos/pesquisa-produto/PesquisaProdutos.tsx": 6370,
	"./components/pesquisa-produtos/pesquisas-anteriores/PesquisasAnteriores.tsx": 91165,
	"./components/pesquisa-produtos/pesquisas-anteriores/PesquisasAnterioresContainer.tsx": 49748,
	"./components/pesquisa-produtos/produtos-fora-estoque/ProdutosForaEstoque.tsx": 89104,
	"./components/pesquisa-produtos/produtos-fora-estoque/ProdutosForaEstoqueContainer.tsx": 82729,
	"./components/pesquisa-produtos/produtos-fora-estoque/produtos-fora-estoque-selecionados/ProdutosForaEstoqueSelecionados.tsx": 11570,
	"./components/popover/Popover.tsx": 15630,
	"./components/relaciona-obra-endereco/RelacionaObraEndereco.tsx": 61689,
	"./components/relaciona-obra-endereco/RelacionaObraEnderecoContainer.tsx": 60928,
	"./components/renderizarOuRemoverComponentReact.tsx": 64734,
	"./components/resumo/ResumoOrcamento.tsx": 18205,
	"./components/resumo/ResumoOrcamentoContainer.tsx": 6996,
	"./components/selecao-com-filtro/DadosItemSelecao.tsx": 25784,
	"./components/selecao-com-filtro/ItemSelecao.tsx": 92558,
	"./components/selecao-com-filtro/SelecaoComFiltro.tsx": 25919,
	"./components/selecionar-colunas-para-exibicao/SelecionarColunasParaExibicao.tsx": 56424,
	"./components/selecionarCodigoTelefoneInternacional/SelecionarCodigoTelefoneInternacional.tsx": 14439,
	"./components/senha-vendedor/SenhaVendedor.tsx": 99782,
	"./components/senha-vendedor/SenhaVendedorContainer.tsx": 50418,
	"./components/senha-vendedor/SenhaVendedorContainerDialog.tsx": 71397,
	"./components/senha/SolicitarSenha.tsx": 86061,
	"./components/senha/SolicitarSenhaContainer.tsx": 40708,
	"./components/separador/Separador.tsx": 95764,
	"./components/servicos-agregados-responsaveis/ResponsaveisServicosAgregados.tsx": 57318,
	"./components/servicos-agregados/ModalServicosAgregados.tsx": 41744,
	"./components/servicos-agregados/ModalServicosAgregadosContainer.tsx": 71734,
	"./components/sharedComponents/Button/IconButtons.tsx": 98099,
	"./components/similares/Similares.tsx": 43163,
	"./components/similares/SimilaresContainer.tsx": 72026,
	"./components/simulacao-preco/ItemSimulacao.tsx": 51282,
	"./components/simulacao-preco/SimuladorPreco.tsx": 9136,
	"./components/simulacao-preco/SimuladorPrecoContainer.tsx": 10567,
	"./components/simulacao-preco/SimuladorPrecoContainerDialog.tsx": 983,
	"./components/sugerir-produto-agregado/SugerirProdutoAgregado.tsx": 26307,
	"./components/sugerir-produto-agregado/SugerirProdutoAgregadoContainer.tsx": 47642,
	"./components/telemetria/telemetria_popup.tsx": 9018,
	"./components/tema/BotaoAlternarTema.tsx": 40577,
	"./components/tinta/EditarPrecoTinta.tsx": 42120,
	"./components/tinta/EditarPrecoTintaContainer.tsx": 69992,
	"./components/tooltip/TooltipMU.tsx": 25534,
	"./components/totalizador/Totalizador.tsx": 81292,
	"./components/totalizador/TotalizadorContainer.tsx": 23038,
	"./components/totalizador/camposDescontoEditaveis.ts": 10088,
	"./components/ultimas-compras-produtos/UltimasComprasProdutos.tsx": 70640,
	"./components/ultimas-compras-produtos/UltimasComprasProdutosContainer.tsx": 96790,
	"./components/ultimas-compras/TableHead/HeaderUltimasCompras.tsx": 51726,
	"./components/ultimas-compras/TableHead/MenuColunasUltimasCompras.tsx": 44641,
	"./components/ultimas-compras/TableHead/TableHeadUltimasCompras.tsx": 11647,
	"./components/ultimas-compras/UltimasCompras.tsx": 89596,
	"./components/ultimas-compras/UltimasComprasContainer.tsx": 21427,
	"./components/unificacao-de-orcamentos/UnificacaoDeOrcamentos.tsx": 38653,
	"./components/unificacao-de-orcamentos/UnificacaoDeOrcamentosContainer.tsx": 42004,
	"./controleSessoesAplicativoAbertasViaWebsockets.ts": 68756,
	"./controllers/clientes/atendimento/cadastroAtendimentoController.js": 37088,
	"./controllers/clientes/atendimento/pesquisarAtendimentoController.js": 138,
	"./controllers/clientes/cadastro/cadastroClienteController.tsx": 71908,
	"./controllers/clientes/cadastro/clienteNaoCadastradoController.js": 32490,
	"./controllers/clientes/cadastro/editarEnderecoController.ts": 53347,
	"./controllers/clientes/pesquisar/acompanhamentoController.js": 17423,
	"./controllers/clientes/pesquisar/creditoController.js": 22878,
	"./controllers/clientes/pesquisar/documentoAbertoController.js": 74055,
	"./controllers/clientes/pesquisar/documentosQuitadosController.js": 11029,
	"./controllers/clientes/pesquisar/fichaCrediarioController.js": 14725,
	"./controllers/clientes/pesquisar/fichaFinanceiraController.js": 73281,
	"./controllers/clientes/pesquisar/limiteCreditoController.js": 39952,
	"./controllers/clientes/pesquisar/orcamentoAbertoController.js": 6027,
	"./controllers/clientes/pesquisar/orcamentosEmAbertoClienteController.js": 48674,
	"./controllers/clientes/pesquisar/pendenciaClienteOrcamentoController.ts": 78476,
	"./controllers/clientes/pesquisar/pesquisarClientesController.tsx": 98265,
	"./controllers/clientes/pesquisar/ultimasComprasController.js": 72698,
	"./controllers/comum/enderecoController.ts": 52756,
	"./controllers/comum/listaCepController.ts": 58990,
	"./controllers/comum/permissaoSenhaVendaController.js": 48026,
	"./controllers/conhecimentoTransporte/listarConhecimentoTransporteController.js": 68542,
	"./controllers/cotacoesPerdidas/pesquisarCotacoesPerdidasController.js": 88244,
	"./controllers/fornecedor/pesquisarFornecedoresController.tsx": 84799,
	"./controllers/home/catalogoController.js": 60436,
	"./controllers/metaBonus/consultarMetaBonusController.tsx": 6065,
	"./controllers/notaFiscalEntrada/CreditoDevolucaoNotaFiscalEntradaController.js": 71921,
	"./controllers/notaFiscalEntrada/ItensNotaFiscalEntradaController.js": 50424,
	"./controllers/notaFiscalEntrada/listarNotasFiscaisEntradaController.js": 415,
	"./controllers/notafiscalSaida/contasReceberNotaFiscalSaidaController.js": 65201,
	"./controllers/notafiscalSaida/entregaNotaFiscalSaidaController.js": 84191,
	"./controllers/notafiscalSaida/expedicaoNotaFiscalSaidaController.js": 16265,
	"./controllers/notafiscalSaida/itensNotaFiscalSaidaController.js": 26626,
	"./controllers/notafiscalSaida/listarNotasFiscaisSaidaController.js": 28371,
	"./controllers/notafiscalSaida/lotesNotaFiscalSaidaController.js": 77430,
	"./controllers/orcamento/Historico/historicoPedidoController.js": 76135,
	"./controllers/orcamento/agregadosController.js": 83252,
	"./controllers/orcamento/autenticarVendedorController.js": 72502,
	"./controllers/orcamento/autorizadoOrcamentoController.js": 14745,
	"./controllers/orcamento/cadastroIndicadorController.ts": 34194,
	"./controllers/orcamento/cancelarOrcamentoController.js": 35016,
	"./controllers/orcamento/compararProdutosController.ts": 27337,
	"./controllers/orcamento/descontosController.js": 22763,
	"./controllers/orcamento/editarEnderecoOrcamentoController.js": 54767,
	"./controllers/orcamento/editarFreteController.ts": 88899,
	"./controllers/orcamento/editarIndicadorController.ts": 79082,
	"./controllers/orcamento/editarItensOrcamentoController.ts": 86367,
	"./controllers/orcamento/editarLoteProdutoController.ts": 44280,
	"./controllers/orcamento/editarParcelaContratoController.ts": 55967,
	"./controllers/orcamento/editarParcelaController.ts": 76511,
	"./controllers/orcamento/editarPrecoTintaController.js": 74927,
	"./controllers/orcamento/editarTipoEntregaOrcamentoController.ts": 98427,
	"./controllers/orcamento/enderecoOrcamentoController.tsx": 37619,
	"./controllers/orcamento/entregaOrcamentoController.ts": 37578,
	"./controllers/orcamento/faturamentoOutrasSaidasController.js": 26514,
	"./controllers/orcamento/finalizarOrcamentoController.tsx": 50390,
	"./controllers/orcamento/formaPagamentoController.ts": 25416,
	"./controllers/orcamento/freteOrcamentoController.js": 96567,
	"./controllers/orcamento/itemOrcamentoController.tsx": 68303,
	"./controllers/orcamento/lotesProdutoController.ts": 81308,
	"./controllers/orcamento/markupOrcamentoController.js": 49267,
	"./controllers/orcamento/menuAcoesProdutosController.js": 2087,
	"./controllers/orcamento/menuAmbientesController.js": 39480,
	"./controllers/orcamento/menuConsultaProdutosController.tsx": 93946,
	"./controllers/orcamento/modalItensOrcamentoController.js": 46959,
	"./controllers/orcamento/orcamentoController.tsx": 46748,
	"./controllers/orcamento/pesquisarIndicadorOrcamentoController.ts": 27878,
	"./controllers/orcamento/pesquisarOrcamentoController.js": 79096,
	"./controllers/orcamento/planoPagamentoController.ts": 48664,
	"./controllers/orcamento/produtosControleLoteController.js": 48757,
	"./controllers/orcamento/profissionalOrcamentoController.ts": 8325,
	"./controllers/orcamento/registrarPerdaCotacaoController.js": 78816,
	"./controllers/orcamento/resumoOrcamentoController.ts": 22811,
	"./controllers/orcamento/simularDescontoItemOrcamentoController.ts": 75771,
	"./controllers/orcamento/simularFinanciamentoController.ts": 87237,
	"./controllers/orcamento/simularPrecoItemOrcamentoController.js": 18414,
	"./controllers/orcamento/tipoDocumentoController.js": 1197,
	"./controllers/orcamento/tipoEntregaOrcamentoController.js": 98785,
	"./controllers/orcamento/transportadoraOrcamentoController.ts": 90788,
	"./controllers/orcamento/trocarFilialOrcamentoController.js": 58795,
	"./controllers/orcamento/ultimasComprasProdutoController.js": 38668,
	"./controllers/orcamento/vendaProdutoEstoqueIndisponivel.js": 46574,
	"./controllers/orcamento/vendedorOrcamentoController.ts": 44541,
	"./controllers/parametros/parametroController.js": 64230,
	"./controllers/produtos/LotesReservadosProdutoConsultaController.js": 77262,
	"./controllers/produtos/PesquisarMovimentacaoEstoqueController.js": 59177,
	"./controllers/produtos/lotesProdutoConsultaController.js": 96580,
	"./controllers/produtos/ofertasProdutoController.js": 4040,
	"./controllers/produtos/pedidoClienteController.js": 31386,
	"./controllers/produtos/pedidoFornecedorController.ts": 16766,
	"./controllers/produtos/pesquisarClassesProdutosController.tsx": 60755,
	"./controllers/produtos/pesquisarEstoqueController.tsx": 91579,
	"./controllers/produtos/pesquisarHistoricoFiltroController.js": 85724,
	"./controllers/produtos/pesquisarPreVendaController.js": 12639,
	"./controllers/produtos/pesquisarProdutosController.ts": 25641,
	"./controllers/produtos/pesquisarReservaController.js": 78188,
	"./controllers/produtos/pesquisarTributacaoController.js": 81362,
	"./controllers/produtos/produtosForaEstoqueController.js": 29553,
	"./controllers/produtos/selecionarCorController.ts": 72161,
	"./controllers/produtos/similaresController.js": 89498,
	"./controllers/produtos/sugerirProdutoAgregadoController.js": 49817,
	"./controllers/vendedor/informacaoController.js": 91005,
	"./estilos/classeParaLabelsFormularioComFundoEscuro.ts": 115,
	"./hooks/useDropdownEncaixarNaTela.ts": 51220,
	"./hooks/useEffectWithPrevious.ts": 54153,
	"./libs/reactInputMask.d.ts": 56139,
	"./libs/reactInputMask.js": 64538,
	"./menuController.ts": 82474,
	"./microuniverso.js": 77167,
	"./models/cliente/acompanhamento.js": 99183,
	"./models/cliente/cliente.js": 12466,
	"./models/cliente/credito.js": 1418,
	"./models/cliente/documento.js": 21210,
	"./models/cliente/fichaCrediario.js": 9557,
	"./models/cliente/fichaFinanceira.js": 84777,
	"./models/cliente/limiteCredito.js": 4060,
	"./models/cliente/orcamentoAberto.js": 51331,
	"./models/fornecedor/fornecedor.ts": 62035,
	"./models/orcamento/ambiente.ts": 11982,
	"./models/orcamento/formaPagamento.js": 53337,
	"./models/orcamento/itemOrcamento.ts": 34254,
	"./models/orcamento/orcamento.ts": 93171,
	"./models/orcamento/parcelas.js": 13775,
	"./models/orcamento/tipoDocumento.js": 7092,
	"./models/produto/estoque.js": 90917,
	"./models/produto/historicoFiltro.js": 85287,
	"./models/produto/pedidoCliente.js": 46718,
	"./models/produto/pedidoFornecedor.js": 22209,
	"./models/produto/preVendaFiltro.js": 94612,
	"./models/produto/prevenda.js": 37402,
	"./models/produto/produto.ts": 17551,
	"./models/produto/reserva.js": 13960,
	"./models/produto/tributacao.js": 42131,
	"./models/vendedor/informacao.js": 59904,
	"./modificacoesDaRefatoracaoAtivadas.ts": 24454,
	"./raw-loader.d.ts": 46905,
	"./redux/ActionType.ts": 1292,
	"./redux/actions/resetAll.ts": 92132,
	"./redux/aguardandoProcessamentoSlice.ts": 15941,
	"./redux/atualizacaoItensOrcamentoLegadoSlice.ts": 25817,
	"./redux/atualizacaoOrcamentoLegadoSlice.ts": 20524,
	"./redux/colunasGridOrcamentoSlice.ts": 14121,
	"./redux/corLinearProgressSlice.ts": 89622,
	"./redux/corPorAmbienteSlice.ts": 15868,
	"./redux/gridItensSlice.ts": 59529,
	"./redux/hooks.ts": 31600,
	"./redux/menuPrincipalSlice.ts": 90417,
	"./redux/middleware/timingMiddleware.ts": 26227,
	"./redux/modeloSlice.ts": 76412,
	"./redux/orcamentoEmAndamentoSlice.ts": 93353,
	"./redux/orcamentoSlice.ts": 15006,
	"./redux/parametrosPorItemSlice.ts": 62074,
	"./redux/parametrosSlice.ts": 40094,
	"./redux/permissoesSlice.ts": 73450,
	"./redux/produtosSelecionadosSlice.ts": 17051,
	"./redux/respostasFinalizacaoOrcamentoSlice.ts": 20657,
	"./redux/store/store.ts": 36437,
	"./redux/telaOrcamentoAlteradaNaoSalvaSlice.ts": 1683,
	"./redux/totalizadorSlice.ts": 39535,
	"./redux/utils/obterItemOrcamentoDaStore.ts": 39027,
	"./stories-utils/ListaFiliais.ts": 67215,
	"./tema.ts": 44072,
	"./types/AbaPlanoPagamento.ts": 67561,
	"./types/AbaTransportadora.ts": 41581,
	"./types/Autorizado.ts": 83369,
	"./types/CMC7.ts": 48869,
	"./types/CalendarioCapacidadeCarga.ts": 49114,
	"./types/CepPorEndereco.ts": 38205,
	"./types/CodigoTipoEntrega.ts": 70832,
	"./types/CodigoTurnoEntrega.ts": 61768,
	"./types/Comissao-por-classificacao/ComissaoPorClassificacao.ts": 84812,
	"./types/ComissoesEndereco.ts": 61851,
	"./types/ControllerLegado.ts": 66005,
	"./types/ConusltarItens.ts": 6617,
	"./types/CotacoesPerdidas.ts": 47632,
	"./types/CupomDesconto/ICampanhaDesconto.ts": 93106,
	"./types/DadosDestinoTransferencia.ts": 62163,
	"./types/DadosEntrega.ts": 74182,
	"./types/DadosMenuPrincipal.ts": 34705,
	"./types/DadosTransportadora.ts": 32096,
	"./types/DataFormatoEN.ts": 93296,
	"./types/DataFormatoPT.ts": 50951,
	"./types/DataHoraFormatoENComT.ts": 81455,
	"./types/Desconto.ts": 79722,
	"./types/Endereco.ts": 65556,
	"./types/FaturamentoOutrasSaidas.ts": 7184,
	"./types/FinalizarOrcamento.ts": 39717,
	"./types/GridPesquisaProduto.ts": 7237,
	"./types/ICentroCusto.ts": 29369,
	"./types/ICidade.ts": 41336,
	"./types/IClassificacao.ts": 48058,
	"./types/ICliente.ts": 28980,
	"./types/IColuna.ts": 88875,
	"./types/IEndereco.ts": 84015,
	"./types/IEstado.ts": 24442,
	"./types/IFilial.ts": 46807,
	"./types/IIndicador.ts": 42155,
	"./types/IItemOrcamento.ts": 31997,
	"./types/ILotes.ts": 21057,
	"./types/ILotesReservados.ts": 75283,
	"./types/IOrcamento.ts": 13864,
	"./types/IPais.ts": 70995,
	"./types/IProduto.ts": 47475,
	"./types/ISegmento.ts": 50214,
	"./types/ITipoEntrega.ts": 11232,
	"./types/ITipoFaturamento.ts": 51940,
	"./types/ITurnoEntrega.ts": 28888,
	"./types/IVendedor.ts": 89059,
	"./types/IdentificadorItem.ts": 80913,
	"./types/IncluirEditarParcela.ts": 24242,
	"./types/LiberarPendenciaResposta.ts": 98928,
	"./types/Madeira.ts": 58426,
	"./types/Markup.ts": 727,
	"./types/MetaBonus.ts": 75275,
	"./types/NovoEndereco.ts": 55280,
	"./types/Obra.ts": 71995,
	"./types/OrdemProducao.ts": 67683,
	"./types/Parametro.ts": 54228,
	"./types/PerdaCotacao.ts": 8733,
	"./types/Permissao.ts": 97272,
	"./types/PesquisaCep.ts": 7444,
	"./types/Resumo.ts": 61814,
	"./types/ServicoAgregado.ts": 58126,
	"./types/Transportadora.ts": 11667,
	"./types/TrocarFilialOrcamento.ts": 66161,
	"./types/Vendedor.ts": 80844,
	"./types/Whatsapp/ConfigurarWhatsappResponse.ts": 37115,
	"./types/Whatsapp/EnumTiposMuWhatsapp.ts": 29658,
	"./types/Whatsapp/EnviarWhatsappOutput.ts": 92478,
	"./types/Whatsapp/StatusWhatsappResponse.ts": 69435,
	"./types/WindowMU.ts": 86437,
	"./types/api/PesquisaProdutosResposta.ts": 78770,
	"./types/api/RespostaPaginada.ts": 18296,
	"./types/cliente/ConsultaAtendimentoForm.ts": 11711,
	"./types/cliente/DadosAtendimento.ts": 37823,
	"./types/cliente/DadosBasicosCliente.ts": 29739,
	"./types/cliente/DadosTemporariosCliente.ts": 15984,
	"./types/cliente/DomainDataPendenciaCliente.ts": 91501,
	"./types/cliente/FiltroOrcamentoAberto.ts": 8003,
	"./types/cliente/FiltroPesquisaClientes.ts": 28256,
	"./types/cliente/FiltroUltimasCompras.ts": 43106,
	"./types/cliente/FiltrosAtendimento.ts": 95047,
	"./types/cliente/PesquisaClienteConsultasPadrao.ts": 54982,
	"./types/cliente/RespostaAcompanhamentos.ts": 93345,
	"./types/cliente/RespostaCadastroCliente.ts": 93416,
	"./types/cliente/RespostaCredito.ts": 36249,
	"./types/cliente/RespostaDocumentosAbertos.ts": 63136,
	"./types/cliente/RespostaDocumentosQuitados.ts": 13512,
	"./types/cliente/RespostaLimiteCredito.ts": 75843,
	"./types/cliente/RespostaListarUltimasCompras.ts": 22652,
	"./types/cliente/RespostaOrcamentosAbertos.ts": 56380,
	"./types/cliente/RespostaPesquisaClasse.ts": 63849,
	"./types/cliente/RespstaUltimasCompras.ts": 51534,
	"./types/comissoes/DadosAdiconais.ts": 13857,
	"./types/comissoes/DadosBasicosIndicadores.ts": 50681,
	"./types/comissoes/Indicadores.ts": 67914,
	"./types/comissoes/Profissionais.ts": 58006,
	"./types/comissoes/Vendedores.ts": 44324,
	"./types/enderecoOrcamento/SalvarEnderecoOrcamento.ts": 5575,
	"./types/modalImprimir/DadosEnviarWhatsapp.ts": 89944,
	"./types/modalImprimir/DadosEnviarWhatsappMuWhatsappApi.ts": 17518,
	"./types/modalImprimir/ModalEnviarEmail.ts": 11710,
	"./types/modalImprimir/RespostaModalImprimir.ts": 9945,
	"./types/orcamento/ItensTotaisOrcamento.ts": 42317,
	"./types/orcamento/MotivoDesconto.ts": 55229,
	"./types/orcamento/PerdaCotacao.ts": 93666,
	"./types/orcamento/consultaItens/RespostaConsultaItensOrcamento.ts": 21540,
	"./types/orcamentoWebSnapshot/OrcamentoWebSnapshot.ts": 9594,
	"./types/pesquisa-orcamento/CancelarOrcamento.ts": 65211,
	"./types/pesquisa-orcamento/PesquisaOrcamento.ts": 73163,
	"./types/pesquisa-orcamento/consultas/ConhecimentoTransporte.ts": 44606,
	"./types/pesquisa-orcamento/consultas/Devolucoes.ts": 64768,
	"./types/pesquisa-orcamento/consultas/Historico.ts": 50371,
	"./types/pesquisa-orcamento/consultas/Lotes.ts": 17294,
	"./types/pesquisa-orcamento/consultas/NotasFiscais.ts": 60664,
	"./types/pesquisa-orcamento/consultas/sub-consultas-devolucoes/CreditoDevolucoes.ts": 33034,
	"./types/pesquisa-orcamento/consultas/sub-consultas-devolucoes/Itens.ts": 99178,
	"./types/pesquisa-orcamento/sub-consultas-notas-fiscais/Entrega.ts": 89181,
	"./types/pesquisa-orcamento/sub-consultas-notas-fiscais/Expedicao.ts": 53851,
	"./types/pesquisa-orcamento/sub-consultas-notas-fiscais/Financeiro.ts": 73407,
	"./types/pesquisa-orcamento/sub-consultas-notas-fiscais/Itens.ts": 87914,
	"./types/produto/FiltroEstoque.ts": 84965,
	"./types/produto/FiltroListarOfertas.ts": 9572,
	"./types/produto/FiltroLotes.ts": 36384,
	"./types/produto/FiltroMovimentacaoEstoque.ts": 28914,
	"./types/produto/FiltroPesquisaConsulta.ts": 29237,
	"./types/produto/FiltroPesquisaProdutos.ts": 67952,
	"./types/produto/FiltroTributacao.ts": 84491,
	"./types/produto/IProduto.ts": 58233,
	"./types/produto/PesquisasAnteriores.ts": 47123,
	"./types/produto/ProdutoForaEstoque.ts": 83494,
	"./types/produto/RespostaOfertas.ts": 11873,
	"./types/produto/RespostaTributacao.ts": 31546,
	"./types/simulacao-preco/ComposicaoCustoSimulacaoPrecoItemContract.ts": 23283,
	"./types/simulacao-preco/ComposicaoSimulacaoPrecoItemContract.ts": 82975,
	"./types/simulacao-preco/SimulacaoPrecoItemContract.ts": 90422,
	"./types/simulacao-preco/TipoPesquisaContract.ts": 60531,
	"./use-cases/atualizarCorLinearProgress.ts": 17976,
	"./use-cases/index.ts": 72677,
	"./use-cases/obterColunasGridItens.ts": 31737,
	"./use-cases/obterDadosLicenciamento.ts": 71319,
	"./use-cases/obterPermissao.ts": 89010,
	"./use-cases/orcamento/AdicionarServicosAgregados.ts": 21419,
	"./use-cases/orcamento/DefinirCodigoMotivoDesconto.ts": 89313,
	"./use-cases/orcamento/DefinirCodigoMotivoDescontoItem.ts": 13878,
	"./use-cases/orcamento/DefinirDescontoAcumuladoSobreMercadoriasImportadas.ts": 98860,
	"./use-cases/orcamento/DefinirTransportadora.ts": 79151,
	"./use-cases/orcamento/RemoverServicosAgregados.ts": 91771,
	"./use-cases/orcamento/adicionarItens.ts": 97587,
	"./use-cases/orcamento/alteracoesPlanoPlagamento.ts": 25131,
	"./use-cases/orcamento/alterarDataMarcadaEntregaItem.ts": 15165,
	"./use-cases/orcamento/alterarDataPrevisaoEntregaItem.ts": 48027,
	"./use-cases/orcamento/alterarDataPrevisaoEntregaItens.ts": 23557,
	"./use-cases/orcamento/alterarDesconto.ts": 15122,
	"./use-cases/orcamento/alterarEntregaPosteriorItem.ts": 49217,
	"./use-cases/orcamento/alterarEntregaPosteriorItens.ts": 67079,
	"./use-cases/orcamento/alterarFormaPagamento.ts": 49736,
	"./use-cases/orcamento/alterarFreteItemOrcamento.ts": 54912,
	"./use-cases/orcamento/alterarMostruarioItem.ts": 7793,
	"./use-cases/orcamento/alterarObra.ts": 62147,
	"./use-cases/orcamento/alterarOrdemPedidoCompraItem.ts": 28242,
	"./use-cases/orcamento/alterarPercentualMarkupItem.ts": 15801,
	"./use-cases/orcamento/alterarPrecoItem.ts": 36007,
	"./use-cases/orcamento/alterarPrecoItemSimulacaoMarkup.ts": 93765,
	"./use-cases/orcamento/alterarQuantidadeItem.ts": 38142,
	"./use-cases/orcamento/alterarTipoEntregaItem.ts": 6766,
	"./use-cases/orcamento/alterarTipoEntregaItens.ts": 53362,
	"./use-cases/orcamento/alterarTipoFreteVariosItensOrcamento.ts": 14736,
	"./use-cases/orcamento/alterarTurnoEntregaItem.ts": 72428,
	"./use-cases/orcamento/ambiente/Ambiente.ts": 52391,
	"./use-cases/orcamento/ambiente/coresAmbientes.ts": 17128,
	"./use-cases/orcamento/ambiente/obterAmbientesPelosItens.ts": 9990,
	"./use-cases/orcamento/ambiente/obterProximaCorAmbiente.ts": 91163,
	"./use-cases/orcamento/aplicarDescontoCashback.ts": 59601,
	"./use-cases/orcamento/atualizarDadosOrcamento.ts": 4766,
	"./use-cases/orcamento/atualizarEntrega.ts": 28289,
	"./use-cases/orcamento/atualizarItemNoOrcamentoLegado.ts": 80557,
	"./use-cases/orcamento/atualizarOrcamento.ts": 5815,
	"./use-cases/orcamento/atualizarOrcamentoResumo.ts": 92018,
	"./use-cases/orcamento/atualizarParcelasFormaPagamentoNoEstadoOrcamento.ts": 74862,
	"./use-cases/orcamento/atualizarRecalcularParcelas.ts": 79566,
	"./use-cases/orcamento/cliente/atualizarClienteOrcamento.ts": 9164,
	"./use-cases/orcamento/cliente/atualizarClientePendente.ts": 18341,
	"./use-cases/orcamento/cliente/cadastroCliente.ts": 61890,
	"./use-cases/orcamento/cliente/removerClienteOrcamento.ts": 63507,
	"./use-cases/orcamento/cliente/salvarClienteOrcamento.ts": 40672,
	"./use-cases/orcamento/cliente/salvarNovoClienteOrcamento.ts": 34804,
	"./use-cases/orcamento/comissoes/detalharComissoesPorIndicador.ts": 73512,
	"./use-cases/orcamento/comissoes/profissionais.ts": 41877,
	"./use-cases/orcamento/comissoes/vendedores.ts": 20873,
	"./use-cases/orcamento/confirmarNovaDataPrevistaCapacidadeDeCarga.ts": 83681,
	"./use-cases/orcamento/corrigirDatasItemOrcamento.ts": 38495,
	"./use-cases/orcamento/corrigirDatasOrcamento.ts": 79114,
	"./use-cases/orcamento/criarOrcamento.ts": 61361,
	"./use-cases/orcamento/definirAdquirirQuantidadeTotalItem.ts": 72621,
	"./use-cases/orcamento/definirAliquotaItem.ts": 70140,
	"./use-cases/orcamento/definirCentroCustoItem.ts": 96979,
	"./use-cases/orcamento/definirDescricaoProdutoItem.ts": 1098,
	"./use-cases/orcamento/definirDespesasInclusas.ts": 28715,
	"./use-cases/orcamento/definirDespesasInclusasParaItensOrcamento.ts": 36582,
	"./use-cases/orcamento/definirEncomendaExpressaItem.ts": 31267,
	"./use-cases/orcamento/definirEntregaPosteriorItem.ts": 5413,
	"./use-cases/orcamento/definirFilialRetiradaItem.ts": 63143,
	"./use-cases/orcamento/definirFilialTransferenciaItem.ts": 73218,
	"./use-cases/orcamento/definirIdCanalDeVenda.ts": 24252,
	"./use-cases/orcamento/definirIdPontoRetiradaItem.ts": 92195,
	"./use-cases/orcamento/definirNovaDataCapacidadeCarga.ts": 68570,
	"./use-cases/orcamento/definirOidModalidadeEntregaItem.ts": 25000,
	"./use-cases/orcamento/definirPedidoDeCompraItem.ts": 65920,
	"./use-cases/orcamento/definirPercentualDesconto.ts": 11827,
	"./use-cases/orcamento/definirPercentualDescontoAcumulado.ts": 92284,
	"./use-cases/orcamento/definirPercentualDescontoAcumuladoSobreMercadoriasImportadas.ts": 18007,
	"./use-cases/orcamento/definirPercentualDescontoAcumuladoSobreMercadoriasNacionais.ts": 94632,
	"./use-cases/orcamento/definirPercentualDescontoMercadoriasImportadas.ts": 92355,
	"./use-cases/orcamento/definirPercentualDescontoMercadoriasNacionais.ts": 94820,
	"./use-cases/orcamento/definirPercentualSeguroEntrega.ts": 86389,
	"./use-cases/orcamento/definirPrecoTintaItem.ts": 54493,
	"./use-cases/orcamento/definirPreservaDesconto.ts": 87658,
	"./use-cases/orcamento/definirPrioridadeMontagemItem.ts": 74091,
	"./use-cases/orcamento/definirRegimeEspecialItem.ts": 97217,
	"./use-cases/orcamento/definirTipoFaturamentoItem.ts": 90218,
	"./use-cases/orcamento/definirValorAcrescimoFinanceiro.ts": 70233,
	"./use-cases/orcamento/definirValorDesconto.ts": 34848,
	"./use-cases/orcamento/definirValorDescontoAcumulado.ts": 87457,
	"./use-cases/orcamento/definirValorDescontoAcumuladoSobreMercadoriasNacionais.ts": 53143,
	"./use-cases/orcamento/definirValorDescontoMercadoriasImportadas.ts": 60938,
	"./use-cases/orcamento/definirValorDescontoMercadoriasNacionais.ts": 62791,
	"./use-cases/orcamento/definirValorFrete.ts": 80297,
	"./use-cases/orcamento/definirValorIPIItem.ts": 3586,
	"./use-cases/orcamento/definirValorSeguroEntrega.ts": 8592,
	"./use-cases/orcamento/definirValorSeguroEntregaTotalizador.ts": 10227,
	"./use-cases/orcamento/definirValorServicosAgregados.ts": 31790,
	"./use-cases/orcamento/definirVendaSobEncomendaItem.ts": 37846,
	"./use-cases/orcamento/dumpOrcamento.ts": 40064,
	"./use-cases/orcamento/editarAmbienteItem.ts": 32677,
	"./use-cases/orcamento/ehNecessarioMostrarModalVendaSobEncomenda.ts": 39082,
	"./use-cases/orcamento/endereco-orcamento/enderecoOrcamento.ts": 9878,
	"./use-cases/orcamento/excluirItens.ts": 89459,
	"./use-cases/orcamento/excluirParcelas.ts": 23459,
	"./use-cases/orcamento/igualarParcelasPrazo.ts": 15348,
	"./use-cases/orcamento/itens/consultas/editarPrecoTintaNoOrcamento.ts": 75234,
	"./use-cases/orcamento/itens/definirOfertaSeletivaItem.ts": 59348,
	"./use-cases/orcamento/liberarPendenciaOrcamento.ts": 75874,
	"./use-cases/orcamento/obterOrcamentoAtual.ts": 22172,
	"./use-cases/orcamento/popularPropriedadesNovoItem.ts": 54550,
	"./use-cases/orcamento/preencherDadosTratamentoMadeira.tsx": 43793,
	"./use-cases/orcamento/recalcularPrecos.ts": 94020,
	"./use-cases/orcamento/registrarPerdaCotacao.ts": 35753,
	"./use-cases/orcamento/removerFormaPagamento.ts": 13181,
	"./use-cases/orcamento/reordenarOrcamento.ts": 11256,
	"./use-cases/orcamento/salvarOrcamento.ts": 86165,
	"./use-cases/orcamento/simularDescontoItem.ts": 51039,
	"./use-cases/orcamento/substituirDataMarcadaDataPrevisaoEntregaItens.ts": 25677,
	"./use-cases/orcamento/tipoOrcamentoSuportaMostruario.ts": 32029,
	"./use-cases/parametro/obterParametro.ts": 72598,
	"./use-cases/parametro/obterParametros.ts": 2261,
	"./use-cases/produto/pesquisarProdutos.ts": 25348,
	"./use-cases/produto/produtoPodeSerAdicionadoAutomaticamenteAoOrcamento.ts": 65116,
	"./use-cases/tratamentoErroPadrao.ts": 78551,
	"./utils/CriaOrcamentoAposTotalizador.ts": 95662,
	"./utils/Dict.ts": 72571,
	"./utils/IsEmptyObject.ts": 40501,
	"./utils/ListaCodigoInternacionalTelefone.ts": 68578,
	"./utils/React-Modern-Calendar-Locale-PtBr.ts": 16337,
	"./utils/UtilsColunas.ts": 24557,
	"./utils/abaEstaViva.ts": 37506,
	"./utils/alturaCabecalhoFixo.ts": 16468,
	"./utils/animacoes.ts": 705,
	"./utils/compareObjects.ts": 26753,
	"./utils/dispositivoSemHover.ts": 31425,
	"./utils/isSistemaOperacionalWindows.ts": 37035,
	"./utils/orcamentoUtil.js": 1954,
	"./utils/tamanhoFonteGrid.ts": 89047,
	"./utils/travaEntreAbas.ts": 84584,
	"./utils/validarCpfCnpj.ts": 99636,
	"./utils/verificacaoContinuaIgualdadeEstados.ts": 48933,
	"./views/cliente/acompanhamentoView.js": 16972,
	"./views/cliente/clienteView.ts": 88770,
	"./views/cliente/creditoView.js": 86313,
	"./views/cliente/detalheClienteView.js": 42154,
	"./views/cliente/documentoView.js": 38837,
	"./views/cliente/fichaCrediarioView.js": 23222,
	"./views/cliente/fichaFinanceiraView.js": 10426,
	"./views/cliente/limiteCreditoView.js": 58723,
	"./views/cliente/orcamentoAbertoView.js": 79192,
	"./views/fornecedor/fornecedorView.tsx": 76402,
	"./views/orcamento/editarItemOrcamentoView.tsx": 29458,
	"./views/orcamento/editarItensOrcamentoView.js": 86897,
	"./views/orcamento/formaPagamentoView.js": 2750,
	"./views/orcamento/itemOrcamentoView.tsx": 91158,
	"./views/orcamento/numeroPedidoView.js": 15640,
	"./views/orcamento/orcamentoView.js": 2161,
	"./views/orcamento/parcelaView.ts": 69340,
	"./views/orcamento/tipoDocumentoView.js": 48839,
	"./views/produto/agregadosView.js": 87625,
	"./views/produto/estoqueProdutoView.js": 51655,
	"./views/produto/historicoFiltroView.js": 95664,
	"./views/produto/pedidoClienteView.js": 18417,
	"./views/produto/pedidoFornecedorView.js": 16414,
	"./views/produto/preVendaView.js": 81233,
	"./views/produto/produtoView.tsx": 33502,
	"./views/produto/reservaProdutoView.js": 79413,
	"./views/produto/similaresView.js": 31745,
	"./views/produto/tributacaoProdutoView.js": 40857,
	"./views/produto/ultimasComprasProdutoView.js": 23169,
	"./views/vendedor/informacaoView.js": 80763
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4838;